import React, { useEffect } from "react";
import { Box, Typography, Button, IconButton, TextField, Chip, Grid, Paper } from "@mui/material";
import { Delete, Download } from "@mui/icons-material";
import { useSelector } from "react-redux";
import MicIcon from "@mui/icons-material/Mic";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import BodySkinMapMale from "../../../../../../common/bodymap/bodyPartSelection";
import BodySkinMapFemale from "../../../../../../common/bodymap/femaleBodyPartSelection";

const CauseForImageManager = ({ prevStep, handleSubmit, selectedPerson, imageData, uploadedImages, uploadedFiles }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store


  // Add download handler
  const handleDownload = (file) => {
    try {
      // Create a URL for the file
      const fileUrl = URL.createObjectURL(file);

      // Create temporary link element
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = file.name; // Set downloaded file name

      // Append to document, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL
      URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  // Add cleanup effect for any remaining object URLs
  useEffect(() => {
    return () => {
      uploadedFiles.forEach((file) => {
        if (file.url) URL.revokeObjectURL(file.url);
      });
    };
  }, [uploadedFiles]);

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>Cause For Concern</Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>
      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />

      <Box sx={{ mt: 1 }}>
        <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>Uploaded Files</Typography>
        {uploadedFiles.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50px",
              bgcolor: "background.paper",
              borderRadius: 1,
              p: 2,
            }}
          >
            <Typography variant='body2' color='text.secondary'>
              No records yet...
            </Typography>
          </Box>
        ) : (
          uploadedFiles.map((file, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mt: 1,
                p: 1,
                border: "1px solid #E0E0E0",
                borderRadius: "4px",
                bgcolor: "background.paper",
                "&:hover": {
                  bgcolor: "#F5F5F5",
                },
              }}
            >
              <TextField variant='outlined' size='small' value={file.name} disabled fullWidth />
              <IconButton
                onClick={() => handleDownload(file)}
                sx={{
                  "&:hover": {
                    color: "#1751D0",
                  },
                }}
              >
                <Download sx={{ color: "#1751D0" }} />
              </IconButton>
              <IconButton
                sx={{
                  "&:hover": {
                    color: "error.main",
                  },
                }}
              >
                <Delete sx={{ color: "error.main" }} />
              </IconButton>
            </Box>
          ))
        )}
      </Box>

      <Grid container>
        <Grid item lg={6} md={6}>
          {selectedPerson === "Male" ? (
            <BodySkinMapMale onUpload={() => {}} uploadedImages={uploadedImages} />
          ) : selectedPerson === "Female" ? (
            <BodySkinMapFemale onUpload={() => {}} uploadedImages={uploadedImages} />
          ) : (
            <></>
          )}
        </Grid>
        <Grid item lg={6} md={6}>
          <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }} mt={20}>
            Provide a description for the selected area
          </Typography>
          {/* Description */}
          <Typography variant='body2' sx={{ color: "#757575", mb: 2 }}>
            Including approximate size and color.
          </Typography>
          {imageData?.map((record, index) => (
            <Paper
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 1,
                mb: 1,
                borderRadius: 2,
                border: "1px solid #ccc",
              }}
            >
              <Typography sx={{ fontSize: "14px", color: "black" }}>
                {record.audio ? (
                  record.behavior
                ) : (
                  <>
                    {record.behavior}
                    <br />
                    {record.note}
                  </>
                )}
              </Typography>

              <Box>
                {record.audio && (
                  <>
                    <IconButton onClick={() => window.open(record.audio, "_blank")}>
                      <MicIcon color='primary' />
                    </IconButton>
                    <IconButton onClick={() => window.open(record.audio, "_blank")}>
                      <CloudDownloadIcon color='primary' />
                    </IconButton>
                  </>
                )}
              </Box>
            </Paper>
          ))}
        </Grid>
      </Grid>

      {/* Footer Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          position: "sticky",
          bottom: 0,
          padding: 2,
          zIndex: 10,
        }}
      >
        <Button
          variant='outlined'
          color='primary'
          onClick={() => {
            window.scrollTo(0, 0); // Prevent scrolling
            prevStep();
          }}
        >
          Previous
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            window.scrollTo(0, 0); // Prevent scrolling
            handleSubmit();
          }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default CauseForImageManager;
